/*
 *
 * Notification Alerts reducer
 *
 */

export const OPEN_NOTIFICATION_ALERT = "OPEN_NOTIFICATION_ALERT";
export const CLOSE_NOTIFICATION_ALERT = "CLOSE_NOTIFICATION_ALERT";
export const initialState = {
  isOpened: false,
  type: "",
  message: null,
};

function notificationsAlertsReducer(state = initialState, action) {
  switch (action.type) {
    case OPEN_NOTIFICATION_ALERT: {
      const { type, message } = action.data;
      return {
        ...state,
        isOpened: true,
        type,
        message,
      };
    }
    case CLOSE_NOTIFICATION_ALERT:
      return {
        ...state,
        isOpened: false,
        type: "",
        message: null,
      };

    default:
      return state;
  }
}

export default notificationsAlertsReducer;
